var map = {
	"./Pokeball.png": 271,
	"./Pokedex.png": 266,
	"./dark.png": 526,
	"./dragon.png": 527,
	"./electric.png": 528,
	"./fairy.png": 529,
	"./fighting.png": 530,
	"./fire.png": 531,
	"./ghost.png": 532,
	"./grass.png": 533,
	"./ground.png": 534,
	"./ice.png": 535,
	"./normal.png": 536,
	"./poison.png": 537,
	"./psychic.png": 538,
	"./rock.png": 539,
	"./steel.png": 540,
	"./unknown.png": 270,
	"./water.png": 541
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 138;


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\.png$
// module id = 138
// module chunks = 4